import React, { useEffect } from 'react';
import DashboardPage from './dashboard/DashboardPage';
import './users/users.css';
import './users/brand.css';
import './dashboard/dashboard.css';
export default function Dashboard() {
  useEffect(() => { document.body.classList.add('users-brand'); return () => document.body.classList.remove('users-brand'); }, []);
  return <DashboardPage />;
}
